import {
    MODIFY_ZONA_TIPO_PARTIDA,
    ADD_ZONA_TIPO_PARTIDA,
    DELETE_ZONA_TIPO_PARTIDA,
} from '../constants/action_types';

export function modifyTipoPartidaDeZona(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_ZONA_TIPO_PARTIDA, payload: tipoPartida });
    }
}

export function addTipoPartidaDeZona(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_ZONA_TIPO_PARTIDA, payload: tipoPartida });
    }
}

export function removeTipoPartidaDeZona(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_ZONA_TIPO_PARTIDA, payload: tipoPartida });
    }
}

